import { DISTRIBUTOR, DOMAIN, ENV } from '@autopass-web/domain';

export const PATH = Object.freeze({
  // bottom tab
  MAIN: '/main',
  MAPS: '/maps',
  ORDERS: '/orders',
  ORDERS_DETAILS: '/orders/details',
  COINS: '/coins',
  MY_MOCHIPASS: '/my-mochipass',

  //  main
  SETTINGS: '/settings',
  PROFILE: '/profile',

  PROMOTION: '/promotion',
  PROMOTION_GROUP: '/promotion/group',
  PROMOTION_DETAIL: '/promotion/detail',
  SERVICES: '/services',
  BARCODE_PAYMENT: '/barcode-payment',
  CONTACT: '/contact',

  // terms
  TERMS: '/terms',
  PAY_TAIPEI_CARDLESS_PARKING_TERMS: '/terms/pay-taipei-cardless-parking',

  // user
  USER_WELCOME: '/user/welcome',
  USER_LOGIN: '/user/login',
  USER_REGISTER: '/user/register',
  USER_ENABLE_STREET_PARKING_AUTO_PAY: '/user/enable-street-parking-autopay',
  USER_ACCOUNT_BINDING: '/user/account-binding',
  USER_ADD_PLATE_NUMBER: '/user/add-plate-number',
  USER_BIND_CARD: '/user/bind-card',
  USER_STREET_PARKING_AUTOPAY_NOTICE: '/user/street-parking-autopay-notice',
  // --- iknow99 ---
  USER_ACTIVATE_PLATE_NUMBER: '/user/activate-plate-number',

  // street parking
  STREET_PARKING_AUTOPAY: '/street-parking/autopay',
  STREET_PARKING_AUTOPAY_BINDING_FAILURE:
    '/street-parking/autopay/binding-failure',

  STREET_PARKING_CITIES: '/street-parking/cities',
  STREET_PARKING_PLATES: '/street-parking/plates',
  STREET_PARKING_BILLS: '/street-parking/bills',

  // payment
  PAYMENT: '/payment',
  PAYMENT_SETTING: '/payment/setting',
  PAYMENT_AUTH: '/payment/auth',

  // Coupon
  COUPON: '/coupon',
  COUPON_EXCHANGE: '/coupon/exchange',
  COUPON_EXPIRED: '/coupon/expired',

  // license plates
  LICENSE_PLATES: '/license-plates',
  LICENSE_PLATES_NEW: '/license-plates/new',
  LICENSE_PLATES_EDIT: '/license-plates/edit',
  // --- iknow99 ---
  LICENSE_PLATES_ACTIVATE: '/license-plates/activate',

  // point
  POINTS: '/points',

  // receipt
  RECEIPT_SETTING: '/receipt-setting',
  RECEIPT_SETTING_DONATE: '/receipt-setting/donate',
  RECEIPT_SETTING_DOWNLOAD: '/receipt-setting/download',

  // else
  SHORTCUT_INSTRUCTION: '/shortcut-instruction',
  EXPIRED: '/expired',
  ANNOUNCEMENT: '/announcement',
  PARKING_RECORDS: '/parking-records',

  GUEST: '/guest',

  // auth
  AUTH: '/auth',
});

export const DIST = process.env.NEXT_PUBLIC_DISTRIBUTOR;
const autopassUrl = DOMAIN.AUTOPASS_URL;

export const dynamicImportComponentsPath = [
  PATH.MAPS,
  PATH.MY_MOCHIPASS,
  PATH.COUPON,
];

export const termsUrl = `${autopassUrl}/terms`;
export const privacyUrl = `${autopassUrl}/privacy`;
export const payTaipeiCardlessParkingTermsUrl = `${autopassUrl}/pay_taipei_cardless_parking_terms`;
export const helperUrl = `https://help.mochipay.xyz`;

export const taipeiParkingBindingFailedHelpUrl = 'https://autopass.vip/jzU54';
export const onStreetParkingBindingFailedHelpUrl = 'https://autopass.vip/4tEDf';

const ENV_CONFIG_DATA = {
  development: {
    AMPLITUDE_KEY: 'f86a3df1a4a2bed2e07b21c20388a8c2',
    // mochi-client
    MOCHI_UID:
      'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60',
    MOCHI_SENTRY_URL:
      'https://e1c6ab50f9e64b038a5090d2591e1c0b@sentry.io/1382812',
    MOCHI_GA: 'UA-124196431-4',
    // cpc
    CPCPAY_UID:
      'bcff0c33c2dc6a79babb27e4809d7429d17a7758d35f861c42ddf36e6c10b00c',
    CPCPAY_SENTRY_URL:
      'https://c35a49f1ff6d46d49aa3f3a5b2458ee0@o121681.ingest.sentry.io/1889477',
    CPCPAY_GA: 'UA-124196431-15',
    // citmkti
    CITIMKT_UID:
      '08f82dd8a4b021a5d80188be76094ea115ef4f1a89811356fb0e4cce9aad3961',
    CITIMKT_SENTRY_URL:
      'https://c35a49f1ff6d46d49aa3f3a5b2458ee0@sentry.io/1889477',
    CITIMKT_GA: 'UA-124196431-16',
    // linebank
    LINEBANK_UID: 'BFLA0qfahaAJlC1SxJpu5EtUvc8wSCXDmDR3hmlOn3Y',
    LINEBANK_SENTRY_URL:
      'https://76a38c143d6b4c3dbfe5d8102fc25174@o121681.ingest.sentry.io/6312462',
    LINEBANK_GA: 'G-S3E4TD8VDR',
    DEEPLINK_INDEX:
      'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/main',
    DEEPLINK_BIND:
      'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/landing?serviceCode=Autopass_CardBinding',
    DEEPLINK_LICENSE_PLATES:
      'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/manage-vehicle-plates ',
    DEEPLINK_HELPER: 'https://www.linebank.com.tw/support/faq/category/10',
    // iknow99
    IKNOW99_UID: '7dJqyHNieVRJ7sFofvEElAi1X7Tj5DAF_MCe3s6S7cc',
    IKNOW99_SENTRY_URL:
      'https://9d5696172ae348518c9e270270f650d1@o121681.ingest.sentry.io/6312459',
    IKNOW99_GA: '',
    // autopartner
    AUTOPARTNER_UID: 'OO_IGjM0NFAfKH2UC6nL2f-StRFcjDvFtcTnGiDyEbc',
    AUTOPARTNER_SENTRY_URL:
      'https://6fbe0db6fb614bf583205bc1058bd673@o121681.ingest.sentry.io/6312464',
    AUTOPARTNER_GA: '',
    // richart life
    RICHARTLIFE_UID: 'eSp4yGLpr0dthouTOlZVPuXenEpGY2m4s_q7NFBkD2I',
    RICHARTLIFE_SENTRY_URL: '',
    RICHARTLIFE_GA: '',
    // npc
    NPCPAY_UID: '77_fkgtIBKNsPqRM5Eo-UEkNv5aNZmMnDFayNLtB1dE',
    NPCPAY_SENTRY_URL:
      'https://14e8de92d20b47949f1c4c9645726aac@o121681.ingest.sentry.io/6474406',
    NPCPAY_GA: '',
    CHAIN_STORE: 'https://chain-store-pay-alpha.pklotcorp.com',
    GLIKE_LINK: 'https://glike.com.tw/line_test.html',
    MARKETING_CONSENT_LINK: 'https://www-alpha.pklotcorp.com/marketing-consent',
  },
  production: {
    AMPLITUDE_KEY: '0c190da3e551d84054f19759f0714d91',
    // mochi-client
    MOCHI_UID:
      '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247',
    MOCHI_SENTRY_URL:
      'https://a25e37fbab1243d4821da9dbbc60e6f8@sentry.io/1382813',
    MOCHI_GA: 'UA-124196431-4',
    // cpc
    CPCPAY_UID:
      'faaa5a2d6cbe1ce16b6830efac52c128d202309a07309a7afdef023c058361fe',
    CPCPAY_SENTRY_URL:
      'https://90d637e347914467b8fc7c7054056856@o121681.ingest.sentry.io/6088626',
    CPCPAY_GA: 'UA-124196431-15',
    // citmkti
    CITIMKT_UID:
      'cb41a7c3c8aa249fce70e78c8c3c8d0e91b32c3263fee247769e1c6a157bac19',
    CITIMKT_SENTRY_URL:
      'https://ffe3751ef0724b8e9714ede08cef0382@sentry.io/1889480',
    CITIMKT_GA: 'UA-124196431-16',
    // linebank
    LINEBANK_UID: '2ecAMkCFnu50162eHJTwTRgzd3QwhrgsqMj14zQ0mnc ',
    LINEBANK_SENTRY_URL:
      'https://0bd4af60673a447eb8cfb1543b5f5337@o121681.ingest.sentry.io/6312460',
    LINEBANK_GA: 'G-S3E4TD8VDR',
    DEEPLINK_INDEX:
      'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/main ',
    DEEPLINK_BIND:
      'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/landing?serviceCode=Autopass_CardBinding ',
    DEEPLINK_LICENSE_PLATES:
      'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/manage-vehicle-plates',
    DEEPLINK_HELPER: 'https://www.linebank.com.tw/support/faq/category/10',
    // iknow99
    IKNOW99_UID: 'PDNMGnwiHpH0vonZuJQCYU8WaZRd8B4SdbCfMr5jNdA',
    IKNOW99_SENTRY_URL:
      'https://c8f15aac15f140c29ae5d041a83b43ae@o121681.ingest.sentry.io/6312455',
    IKNOW99_GA: '',
    // autopartner
    AUTOPARTNER_UID: 'EP6DskS5UXZ4lgFmIQcHu7NGpyzbwzLvr8VAIqqXecE',
    AUTOPARTNER_SENTRY_URL:
      'https://e54acbd7b87343f990869f4c3018c0be@o121681.ingest.sentry.io/6312463',
    AUTOPARTNER_GA: '',
    // richart life
    RICHARTLIFE_UID: 'zFgiE9AvgEODIfR97JCe4Yb5q0mZCgGgs-0PaLU9IIw',
    RICHARTLIFE_SENTRY_URL: '',
    RICHARTLIFE_GA: '',
    // npc
    NPCPAY_UID: 'vXqMc68EGmKxu_UoGRdGlb4cJRbQY1pohY_5VrODBpo',
    NPCPAY_SENTRY_URL:
      'https://dcce19adbe6e43f6b61c56e69bf93d59@o121681.ingest.sentry.io/6474399',
    NPCPAY_GA: '',
    CHAIN_STORE: 'https://chain-store-pay.autopass.xyz',
    GLIKE_LINK: 'https://glike.com.tw/autopasstoline.html',
    MARKETING_CONSENT_LINK: 'https://www.autopass.xyz/marketing-consent',
  },
};

export const ENV_CONFIG = ENV_CONFIG_DATA[ENV];

const legacyDistributorList = [
  DISTRIBUTOR.CPCPAY,
  DISTRIBUTOR.NPCPAY,
  DISTRIBUTOR.LINE_BANK,
  DISTRIBUTOR.IKNOW99,
];

export const isLegacyDistributor = legacyDistributorList.indexOf(DIST) !== -1;

export * from './query-string-keys';
